<template>
    <div class="sim-gallery"
         :class="[`sim-gallery--${type}`, {
             'sim-gallery--active': active,
         }]"
    >
        <div v-if="media instanceof ProductImageModel"
             class="sim-gallery__media-wrapper sim-gallery__media-wrapper--image"
        >
            <CoreImg
                :src="media.imageUrl"
                :alt="media.description"
                class="sim-gallery__media"
                :class="`sim-gallery__media--${type}`"
                sizes="100vw sm:100vw md:50vw lg:33vw"
                :placeholder="[28*2, 28*2, 100, 4]"
            />
        </div>
        <div v-else-if="media instanceof ProductVideoModel"
             class="sim-gallery__media-wrapper sim-gallery__media-wrapper--video"
        >
            <lite-youtube v-if="type !== 'thumb'"
                          class="mx-auto h-full"
                          :videoid="media.videoId"
                          :playlabel="'TODO'"
            />
            <img
                v-else-if="media.getThumbnailUrl()"
                class="sim-gallery__media"
                :class="`sim-gallery__media--${type}`"
                width="132"
                height="132"
                :src="media.getThumbnailUrl() ?? undefined"
                :alt="media.description ?? ''"
            >

            <IconPlay v-if="type === 'thumb'" class="sim-gallery__play" />
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ProductImageModel, ProductVideoModel } from '#imports'

const {
    media,
    type,
    active,
} = defineProps<{
    media: InstanceType<typeof ProductImageModel> | InstanceType<typeof ProductVideoModel>
    type: 'main' | 'thumb'
    active?: boolean
}>()
</script>

<style lang="scss" scoped>
$mobile-size: 5rem;
$desktop-size: 6.5rem;

.sim-gallery--main {
    height: 100%;
}

.sim-gallery__media-wrapper {
    height: 100%;
}

.sim-gallery--thumb .sim-gallery__media-wrapper {
    position: relative;
    width: $mobile-size;
    height: $mobile-size;
    background-color: transparent;
    cursor: pointer;
    border-radius: $sim-border-radius-xs;
    overflow: hidden;
    border: 1.5px solid transparent;
    transition: border-color $sim-trans-time-short $sim-timing;

    &:hover {
        border-color: $sim-c-primary-600;
    }

    @include more-than(sm) {
        width: $desktop-size;
        height: $desktop-size;
    }
}

.sim-gallery--thumb.sim-gallery--active .sim-gallery__media-wrapper {
    border-color: $sim-c-simplo;
}

.sim-gallery--thumb .sim-gallery__media-wrapper--video {
        &::after {
        content: "";
        position: absolute;
        inset: 0;
        opacity: 0.5;
        background-color: $sim-c-basic-900;
    }
}

.sim-gallery__media {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.sim-gallery__media--thumb {
    object-fit: cover;
}

.sim-gallery__media-wrapper--image .sim-gallery__media--thumb {
    object-fit: contain;
    background-color: white;
    padding: 0.375rem;
    box-sizing: border-box;
}

.sim-gallery__play {
    top: 50%;
    left: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
    z-index: 1;
}
</style>
